import { render, staticRenderFns } from "./ChatQuestion.vue?vue&type=template&id=160c160c&scoped=true&"
import script from "./ChatQuestion.vue?vue&type=script&lang=js&"
export * from "./ChatQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ChatQuestion.vue?vue&type=style&index=0&id=160c160c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c160c",
  null
  
)

export default component.exports